import { tableInfoConstants } from "../actions/types";
const initialState = {
    info: undefined,
    type: "",
};
export const tableInfoReducer = (state = initialState, action) => {
    switch (action.type) {
        case tableInfoConstants.SET_TABLE_INFO:
            return Object.assign(Object.assign({}, state), { info: action.payload });
        case tableInfoConstants.SET_TABLE_TYPE:
            return Object.assign(Object.assign({}, state), { type: action.payload });
        default:
            return state;
    }
};
